

import { Actions, Mutations } from '@/store/enums/StoreEnums';
import { Module, Action, Mutation, VuexModule } from 'vuex-module-decorators';


@Module
export default class PaginationModule extends VuexModule {
	
    paginationParams = {};
    
	
	/**
	 * Get current user object
	 * @returns User
	 */
	get getPaginationParams() {
		return (payload) => {
			return this.paginationParams[payload.key];
		}
	}
	get getPaginationTotalItems() {
		return (payload) => {
			return this.paginationParams[payload.key].totalItems;
		}
	}
	@Action({ rawError: true })
	[Actions.SET_PAGINATION_PARAMS](payload) {
		this.context.commit(Mutations.SET_PAGINATION_PARAMS, {paginationDataString: payload.data, key:payload.key});
	}
	@Action({ rawError: true })
	[Actions.RESET_PAGINATION_PARAMS](payload) {
		this.context.commit(Mutations.RESET_PAGINATION_PARAMS,{data: payload.data, key:payload.key});
	}

	@Mutation
	[Mutations.SET_PAGINATION_PARAMS](payload) {
	
		const paginationData = JSON.parse(payload.paginationDataString);
		this.paginationParams[payload.key].paginate = paginationData.PageSize;
		this.paginationParams[payload.key].pages = paginationData.TotalPages;
		this.paginationParams[payload.key].totalItems = paginationData.TotalCount;
		this.paginationParams[payload.key].hasNext = paginationData.HasNext;
		this.paginationParams[payload.key].hasPrev = paginationData.HasPrevious;
		this.paginationParams[payload.key].currentPage = paginationData.CurrentPage;
	}
	@Mutation
	[Mutations.RESET_PAGINATION_PARAMS](payload) {
		this.paginationParams[payload.key] = {
			paginate: 10,
			totalItems: 10,
			currentPage: 1,
			hasNext: false,
			hasPrev: false,
			pages: 0,    
		}
	
	}
}
